import React from 'react';
import { priceRows } from '../data/content';
import { CtaButton } from './ui/CtaButton';
export function Pricing() {
  return <section id="oferta" className="w-full bg-white" data-id="element-115" data-mp="2aqj5pjswb8jo">
      <div className="mx-auto max-w-content px-6 py-20" data-id="element-116" data-mp="2oifv3g36j4cd">
        <h2 className="text-center font-display text-[24px] font-bold leading-tight text-ink sm:text-[27px]" data-id="element-117" data-mp="2ohxnxoezb5po">
          Specjalna oferta startowa
        </h2>

        <div className="mx-auto mt-8 max-w-sm" data-id="element-118" data-mp="1vt9z5iv0ty7d">
          <div className="flex justify-center" data-id="element-119" data-mp="1vw4it867nezq">
            <span className="rounded-full bg-coral px-4 py-1.5 text-[9px] font-bold uppercase tracking-[0.16em] text-white" data-id="element-120" data-mp="1rt8781f38j5a">
              Tylko dla pierwszych 100 osób
            </span>
          </div>

          <div className="mt-4 rounded-2xl border border-coral/25 bg-cream p-6 shadow-[0_28px_60px_-38px_rgba(36,28,24,0.45)]" data-id="element-121" data-mp="20sv6oho9bevp">
            <dl className="space-y-3" data-id="element-122" data-mp="3h5tlswgab3o1">
              {priceRows.map(row => <div key={row.label} className="flex items-baseline justify-between gap-4 border-b border-dashed border-ink/10 pb-3" data-id="element-123" data-mp="3c7i8gbqs6b12">
                  <dt className="text-[11px] text-muted" data-id="element-124" data-mp="4s4ab7stylgb">{row.label}</dt>
                  <dd className="text-[11px] font-semibold text-muted line-through" data-id="element-125" data-mp="9si9e0cgel27">
                    {row.value}
                  </dd>
                </div>)}
              <div className="flex items-baseline justify-between gap-4" data-id="element-126" data-mp="eoz8fpl6yju2">
                <dt className="text-[10px] font-bold uppercase tracking-[0.14em] text-ink" data-id="element-127" data-mp="3daigzee3kofa">
                  Wartość pakietu
                </dt>
                <dd className="font-display text-[13px] font-bold text-coral line-through" data-id="element-128" data-mp="3n7eujyius0qp">
                  664 zł
                </dd>
              </div>
            </dl>

            <div className="mt-6 text-center" data-id="element-129" data-mp="3rzohd5oo8kor">
              <p className="text-[9px] font-semibold uppercase tracking-[0.18em] text-muted" data-id="element-130" data-mp="2uhenbt0vqbko">
                Dziś zapłacisz
              </p>
              <p className="mt-1 font-display text-[38px] font-bold leading-none text-coral" data-id="element-131" data-mp="2zfg427au1ysz">
                69 PLN
              </p>
              <p className="mt-3 text-[10px] leading-relaxed text-muted" data-id="element-132" data-mp="2mibdjcj6miku">
                Jednorazowa płatność. Dostęp na zawsze, bez subskrypcji.
              </p>
            </div>

            <div className="mt-6" data-id="element-133" data-mp="2w7l42nydnt6u">
              <CtaButton href="https://plastyk-gotowa.impultienda.ar/checkout" className="w-full" data-id="element-134" data-mp="2w8mhv06s2ts9" />
            </div>

            <p className="mt-4 text-center text-[9px] text-muted/80" data-id="element-135" data-mp="23ixh8nxzcvr6">
              Bezpieczna płatność · Faktura na życzenie · 14 dni gwarancji
            </p>
          </div>
        </div>
      </div>
    </section>;
}